import { App as AntApp, ConfigProvider } from 'antd';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AppProviders } from '@/app/AppProviders';
import AdminRoute from '@/components/AdminRoute';
import ProtectedRoute from '@/components/ProtectedRoute';
import RouteTransition from '@/components/RouteTransition';
import { Path } from '@/enums';
import {
  AdminLayout,
  GradientLayout,
  ProfileLayout,
  PublicLayout,
  RootLayout,
} from '@/layouts';
import { QuestionnaireLayout } from '@/layouts/QuestionnaireLayout';
import * as Pages from '@/pages';
import ProfilePage from '@/pages/ProfilePage';

export default function App() {
  return (
    <ConfigProvider
      theme={{
        cssVar: true,
        hashed: false,
        token: {
          colorSplit: '#102b28',
          lineHeight: 1.5,
        },
      }}
    >
      <AntApp
        message={{ maxCount: 3 }}
        notification={{ placement: 'topRight' }}
      >
        <AppProviders>
          <BrowserRouter>
            <RouteTransition />
            <Routes>
              <Route element={<RootLayout />}>
                {/* Public Routes */}
                <Route element={<PublicLayout />}>
                  <Route path={Path.Root} element={<Pages.Root />} />
                  {/* Experiment page - only available in development */}
                  {process.env.NODE_ENV === 'development' && (
                    <Route
                      path={Path.Experiment}
                      element={<Pages.Experiment />}
                    />
                  )}
                  <Route
                    path={Path.Unauthorized}
                    element={<Pages.Unauthorized />}
                  />
                  <Route path={Path.Else} element={<Pages.NotFound />} />
                </Route>

                {/* Auth Routes */}
                <Route element={<GradientLayout />}>
                  <Route path={Path.Login} element={<Pages.Login />} />
                  <Route path={Path.Register} element={<Pages.Register />} />
                  <Route
                    path={Path.VerifyEmail}
                    element={<Pages.VerifyEmail />}
                  />
                  <Route
                    path={Path.ForgotPassword}
                    element={<Pages.ForgotPassword />}
                  />
                  <Route
                    path={Path.ResetPassword}
                    element={<Pages.ResetPassword />}
                  />
                </Route>

                {/* Protected Routes */}
                <Route element={<ProtectedRoute />}>
                  <Route element={<GradientLayout />}>
                    <Route
                      path={Path.QuestionnaireSelection}
                      element={<Pages.QuestionnaireSelection />}
                    />
                  </Route>
                  <Route element={<ProfileLayout />}>
                    <Route path={Path.Profile} element={<ProfilePage />} />
                  </Route>
                  <Route element={<QuestionnaireLayout />}>
                    <Route
                      path={Path.Questionnaire}
                      element={<Pages.Questionnaire />}
                    />
                  </Route>
                </Route>

                {/* Public Result Routes */}
                <Route element={<PublicLayout />}>
                  <Route path={Path.Result} element={<Pages.Result />} />
                </Route>

                {/* Admin Routes */}
                <Route element={<AdminRoute />}>
                  <Route element={<AdminLayout />}>
                    <Route
                      path={Path.AdminDashboard}
                      element={<Pages.AdminDashboard />}
                    />
                    <Route
                      path={Path.AdminUsers}
                      element={<Pages.AdminUsersPage />}
                    />
                    <Route
                      path={Path.AdminQuestions}
                      element={<Pages.AdminQuestionsPage />}
                    />
                    <Route
                      path={Path.AdminQuestionModules}
                      element={<Pages.AdminQuestionModulesPage />}
                    />
                    <Route
                      path={Path.AdminAnswerOptionSets}
                      element={<Pages.AdminAnswerOptionSetsPage />}
                    />
                    <Route
                      path={Path.AdminQuestionnaires}
                      element={<Pages.AdminQuestionnairesPage />}
                    />
                    <Route
                      path={Path.AdminResults}
                      element={<Pages.AdminResultsPage />}
                    />
                    <Route
                      path={Path.AdminApiLogs}
                      element={<Pages.AdminApiLogsPage />}
                    />
                  </Route>
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </AppProviders>
      </AntApp>
    </ConfigProvider>
  );
}
